import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_CUISINE_TYPE_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateCuisineTypeImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_CUISINE_TYPE_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateCuisineTypeImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.cuisineTypes.cuisineType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_CUISINE_TYPE_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateCuisineTypeImageDetailsArgs(data) },
        dispatch,
        UPDATE_CUISINE_TYPE_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateCuisineTypeImageDetailsMutation
